import AlgoliaCollection from '@components/collection/AlgoliaCollection'
import { Layout } from '@components/common'
import Search from '@components/search'
import SearchClient from '@lib/algolia'
import getGlobalStaticProps from '@lib/get-global-static-props'
import { createClient } from '@lib/prismicio'
import { AnalyticsPageType } from '@shopify/hydrogen-react'
import type {
  GetServerSidePropsContext,
  InferGetServerSidePropsType,
} from 'next'
import { NextSeo } from 'next-seo'
import { findResultsState } from 'react-instantsearch-dom/server'

export async function getServerSideProps({
  query,
  locale,
  previewData,
}: GetServerSidePropsContext) {
  const client = createClient({ previewData })
  const globalProps = await getGlobalStaticProps(client, locale)

  const q = Array.isArray(query.q) ? query.q[0] : query.q ?? ''
  const algoliaIndex = process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_PRIMARY_INDEX!
  const resultsState = await findResultsState(AlgoliaCollection, {
    searchClient: SearchClient,
    indexName: algoliaIndex,
    exactIndexName: algoliaIndex,
    searchState: q ? { query: q, q } : {},
    defaultCategory: '',
  })

  return {
    props: {
      ...globalProps,
      algoliaIndex,
      resultsState: JSON.parse(JSON.stringify(resultsState)),
      analyticsPayload: {
        pageType: AnalyticsPageType.search,
      },
    },
  }
}

const SearchPage = ({
  algoliaIndex,
  resultsState,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  return (
    <>
      <NextSeo
        noindex
        canonical={`https://${process.env.NEXT_PUBLIC_SITE_DOMAIN}/search`}
      />
      <Search algoliaIndex={algoliaIndex} resultsState={resultsState} />
    </>
  )
}

SearchPage.Layout = Layout

export default SearchPage
